import { NavLink } from 'react-router-dom'
import { useT } from '../i18n/context'
import type { DictPath } from '../i18n/translate'

export interface PageTabItem {
    to: string
    labelKey: DictPath
}

/**
 * URL-gesteuerte Tab-Leiste für Gruppen-Seiten: jeder Tab ist ein NavLink,
 * der aktive Zustand folgt der Route — Deep-Links und Browser-Back inklusive.
 */
export function PageTabs({ tabs }: { tabs: readonly PageTabItem[] }) {
    const t = useT()
    return (
        <div className='flex w-fit max-w-full overflow-x-auto rounded-lg border border-slate-300 dark:border-slate-600'>
            {tabs.map(tab => (
                <NavLink
                    key={tab.to}
                    to={tab.to}
                    className={({ isActive }) =>
                        `whitespace-nowrap px-4 py-1.5 text-sm font-medium transition-colors ${
                            isActive
                                ? 'bg-indigo-700 dark:bg-indigo-600 text-white'
                                : 'bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/60'
                        }`
                    }
                >
                    {t(tab.labelKey)}
                </NavLink>
            ))}
        </div>
    )
}
